import { template } from "@ember/template-compiler";
import { LinkTo } from "@ember/routing";
import dIcon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
export default template(`
  <LinkTo class="btn btn-flat back-button" @route={{@route}}>
    {{dIcon "chevron-left"}}
    {{i18n "back_button"}}
  </LinkTo>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
